<template>
  <BottomPanel :is-open="isPanelOpen" :is-collapsed="isCollapsed" :has-close="canClose" @close="close">
    <template #header>
      <ProcessingPanelHeader :counter-text="counterText" :is-collapsed="isCollapsed" :has-only-failed-videos="hasOnlyFailedVideos" @toggle-collapse="toggleCollapse" />
    </template>
    <div class="banner">
      <p class="banner-text">
        {{ $t('processing-videos-banner-message') }}
      </p>
    </div>
    <div v-if="isLoading" class="processing-panel-loading">
      <LoadingSpinner size="small" />
    </div>
    <div v-else class="processing-panel-list">
      <template v-for="video in processingVideos" :key="video.video_id">
        <ProcessingPanelFailedItem v-if="video.status === ProcessingVideoStatus.Failed" :video="video" @remove="removeItem(video.video_id)" />
        <ProcessingPanelItem v-else :video="video" @remove="removeItem(video.video_id)" />
      </template>
    </div>
  </BottomPanel>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted } from 'vue'
import BottomPanel from '@/components/common/BottomPanel.vue'
import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
import { useProcessingPanel } from '@/composables/useProcessingPanel/useProcessingPanel'
import { useVideoPolling } from '@/composables/useVideoPolling/useVideoPolling'
import ProcessingPanelHeader from '@/components/processing-panel/ProcessingPanelHeader.vue'
import ProcessingPanelItem from '@/components/processing-panel/ProcessingPanelItem.vue'
import ProcessingPanelFailedItem from '@/components/processing-panel/ProcessingPanelFailedItem.vue'
import { ProcessingVideoStatus, VideoPollingSource } from '@/services/videos/types'

const { isPanelOpen, isCollapsed, isLoading, processingVideos, counterText, hasOnlyFailedVideos, canClose, toggleCollapse, close, removeItem } = useProcessingPanel()

const { startPolling, stopPolling } = useVideoPolling()

onMounted(() => {
  startPolling(VideoPollingSource.VideoUpload)
})

onBeforeUnmount(() => {
  stopPolling(VideoPollingSource.VideoUpload)
})
</script>

<style scoped lang="scss">
.processing-panel-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 16px;
  min-height: 120px;
}

.processing-panel-list {
  max-height: 400px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: $display-neutrals-300;
    border-radius: 3px;
  }
}

.banner {
  background: $info-blue-background;
  border: 1px solid $info-blue-border;
  padding: 8px 16px;

  &-text {
    font-size: 14px;
    color: $bodyText;
    margin: 0;
  }
}
</style>
